import { render } from "./inviteBtn.vue?vue&type=template&id=f8126f12&scoped=true"
import script from "./inviteBtn.vue?vue&type=script&lang=js"
export * from "./inviteBtn.vue?vue&type=script&lang=js"

import "./inviteBtn.vue?vue&type=style&index=0&id=f8126f12&scoped=true&lang=css"

import exportComponent from "/Users/yxgc/Desktop/DATA/res/WorldPress/beeNetPlugin/Bee_RewardPlugin/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8126f12"]])

export default __exports__